import React, { useEffect } from 'react';

export const ValueResizeObserver: React.FC<React.PropsWithChildren> = ({ children }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const observedElement = ref.current;

  useEffect(() => {
    if (!observedElement) {
      return;
    }

    const observer = new window.ResizeObserver(() => {
      const height = Math.ceil(observedElement.getBoundingClientRect().height);

      setTimeout(() => {
        // eslint-disable-next-line no-restricted-syntax
        window.parent.postMessage(
          JSON.stringify({ method: 'resize', height: Math.max(height, 1) }),
          '*'
        );
      }, 0);
    });
    const registerValueResizeObserver = () => {
      observer.observe(observedElement);
    };

    registerValueResizeObserver();

    return () => {
      observer.unobserve(observedElement);
    };
  }, [observedElement]);

  return (
    <div ref={ref} data-testid="value-resize-observer">
      {children}
    </div>
  );
};
